<script setup lang="ts">
import BaseModal from '@/components/modal/BaseModal.vue';
import ModalFooterConfirmButtons from '@/components/modal/ModalFooterConfirmButtons.vue';
import { IMindShareChoiceRoomModalProps } from '@/stores/modal';
import { IMeditationRoom } from '@/types/meditation';
import { ref } from 'vue';

const props = defineProps<{
  selectedRoomItem: IMindShareChoiceRoomModalProps['selectedRoomItem'];
  onConfirm: (mode: 'edit' | 'create', selectedRoomItem: Partial<IMeditationRoom>) => void;
  mode: 'edit' | 'create';
}>();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const title = ref(props.selectedRoomItem?.title || '');
const time = ref(props.selectedRoomItem?.time || '');
const linkUrl = ref(props.selectedRoomItem?.link_url || '');

const isSubmitting = ref(false);

const handleClose = () => {
  emit('close');
};

const handleConfirm = () => {
  isSubmitting.value = true;

  if (props.mode === 'edit') {
    if (!props.selectedRoomItem) return;
    props.onConfirm(props.mode, {
      ...props.selectedRoomItem,
      title: title.value,
      time: time.value,
      link_url: linkUrl.value,
    });
  } else {
    props.onConfirm(props.mode, {
      title: title.value,
      time: time.value,
      link_url: linkUrl.value,
    });
  }

  // 약간의 지연 후 로딩 상태 해제
  setTimeout(() => {
    isSubmitting.value = false;
    handleClose();
  }, 300);
};
</script>

<template>
  <BaseModal
    :title="mode === 'edit' ? '나누기방 정보 수정하기' : '나누기방 추가하기'"
    width="360px"
    wrapper-class="gap-3"
    @close="handleClose"
  >
    <div class="flex flex-col gap-4 mt-6 mb-8">
      <InputRow :max-length="100" v-model="title" label="방 제목" />
      <InputRow :max-length="100" v-model="time" label="시작 시간" />
      <InputRow :max-length="100" v-model="linkUrl" label="링크 URL" />
    </div>

    <template #footer>
      <ModalFooterConfirmButtons
        cancel-text="취소"
        :confirm-text="mode === 'edit' ? '수정하기' : '추가하기'"
        :disabled="!title || !time || !linkUrl"
        @cancel="handleClose"
        @confirm="handleConfirm"
        :is-loading="isSubmitting"
      />
    </template>
  </BaseModal>
</template>
